import { FinancialDebtSideBarFilterDatamodel } from '../side-bar-filter/financial-debt-side-bar-filter-datamodel';
import { StudentFinancialDept } from '../../../../../api/types/reports/finanace/student-financial-dept';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getStudentFinancialDeptOperation = async (
  filters: FinancialDebtSideBarFilterDatamodel,
  setData: (data: StudentFinancialDept[]) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getStudentFinancialDept(filters);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(
      `getStudentFinancialDeptOperation is failed with the filters: ${filters} and the error: ${e}`,
    );
  }
};
